import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
  IonButton,
  IonIcon,
  IonInput,
  IonPage,
  IonSpinner,
  IonContent,
} from '@ionic/react';
import { lockClosedOutline, personOutline, peopleOutline, eyeOutline, eyeOffOutline, checkmarkCircleOutline, alertCircleOutline } from 'ionicons/icons';
import { AppBackground } from '../../components/PageHeader';
import './login.css';
import { API_BASE_URL } from '../../config';

const RecuperarContrasena: React.FC = () => {
  const history = useHistory();
  const [nickname, setNickname] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // Password visibility states
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (newPassword !== confirmPassword) {
      setError('La nueva contraseña y la confirmación no coinciden.');
      return;
    }

    if (newPassword.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nickname, newPassword }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al restablecer la contraseña');
        return;
      }

      setSuccess('Contraseña restablecida con éxito. Redirigiendo...');
      // Limpiar campos
      setNickname('');
      setNewPassword('');
      setConfirmPassword('');

      // Redirigir al login
      setTimeout(() => {
        history.push('/');
      }, 2500);

    } catch (err) {
      setError('No se pudo conectar con el servidor. Verifica tu conexión.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage className="app-page login-page">
      <AppBackground variant="auth" />

      <div className="login-wrapper">
        <div className="login-logo">
          <div className="logo-circle">
            <IonIcon icon={peopleOutline} />
          </div>
          <h2 className="app-name">Referidos</h2>
        </div>

        <div className="login-card">
          <h1 className="login-title">Recuperar Contraseña</h1>
          <p className="login-subtitle">Ingresa tu usuario y establece tu nueva contraseña.</p>

          <form onSubmit={handleSubmit} className="app-form">
            {/* Nickname / Usuario */}
            <div className="input-group">
              <span className="input-icon">
                <IonIcon icon={personOutline} />
              </span>
              <IonInput
                type="text"
                placeholder="Usuario o nickname"
                value={nickname}
                onIonInput={(e: any) => setNickname(e.detail.value ?? '')}
                className="app-input"
                required
                disabled={loading}
              />
            </div>

            {/* Nueva Contraseña */}
            <div className="input-group">
              <span className="input-icon">
                <IonIcon icon={lockClosedOutline} />
              </span>
              <IonInput
                type={showNew ? 'text' : 'password'}
                placeholder="Nueva contraseña"
                value={newPassword}
                onIonInput={(e: any) => setNewPassword(e.detail.value ?? '')}
                className="app-input"
                required
                disabled={loading}
              />
              <span
                className="input-icon-right"
                onClick={() => setShowNew(!showNew)}
              >
                <IonIcon icon={showNew ? eyeOffOutline : eyeOutline} />
              </span>
            </div>

            {/* Confirmar Nueva Contraseña */}
            <div className="input-group">
              <span className="input-icon">
                <IonIcon icon={lockClosedOutline} />
              </span>
              <IonInput
                type={showConfirm ? 'text' : 'password'}
                placeholder="Confirmar nueva contraseña"
                value={confirmPassword}
                onIonInput={(e: any) => setConfirmPassword(e.detail.value ?? '')}
                className="app-input"
                required
                disabled={loading}
              />
              <span
                className="input-icon-right"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                <IonIcon icon={showConfirm ? eyeOffOutline : eyeOutline} />
              </span>
            </div>

            {error && (
              <div className="status-alert alert-error">
                <IonIcon icon={alertCircleOutline} />
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="status-alert alert-success">
                <IonIcon icon={checkmarkCircleOutline} />
                <span>{success}</span>
              </div>
            )}

            <IonButton
              type="submit"
              expand="block"
              className="app-btn-primary"
              disabled={loading}
            >
              {loading ? <IonSpinner name="crescent" /> : 'Restablecer Contraseña'}
            </IonButton>

            <p className="login-footer-link">
              <Link className="app-link" to="/">Volver al inicio de sesión</Link>
            </p>
          </form>
        </div>
      </div>
    </IonPage>
  );
};

export default RecuperarContrasena;
